import React, { useState } from 'react';
import './styles/global.css';
import './styles/components.css';
import './styles/sections.css';
import './styles/footer.css';
import './styles/about.css';

import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HeroSection from './components/sections/HeroSection';
import AboutSection from './components/sections/AboutSection';
import CourseFeaturesSection from './components/sections/CourseFeaturesSection';
import TargetAudienceSection from './components/sections/TargetAudienceSection';
import TestimonialsSection from './components/sections/TestimonialsSection';
import CallToActionSection from './components/sections/CallToActionSection';
import CoursesSection from './components/sections/CoursesSection';
import ContactModal from './components/ContactModal';

function App() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const openContactModal = () => {
    setIsContactModalOpen(true);
  };

  const closeContactModal = () => {
    setIsContactModalOpen(false);
  };

  return (
    <div className="app">
      <Header openContactModal={openContactModal} />
      <main>
        <HeroSection openContactModal={openContactModal} />
        <AboutSection />
        <CourseFeaturesSection />
        <CoursesSection openContactModal={openContactModal} />
        <TargetAudienceSection />
        <CallToActionSection openContactModal={openContactModal} />
        <TestimonialsSection />
      </main>
      <Footer openContactModal={openContactModal} />
      <ContactModal isOpen={isContactModalOpen} onClose={closeContactModal} />
    </div>
  );
}

export default App;
